import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CompanyContact from './icon-company-contact.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CompanyContact {...validProps} />;
}

SvgComponent.iconName = 'company-contact';

/**
 * @deprecated This is a legacy icon
 */
export const CompanyContactIcon = svgIconWrapper(SvgComponent);
